import React, { useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';

import FormInput from '../../../components/form/FormInput';
import FormToggle from '../../../components/form/FormToggle';

import { smtpAdd, smtpUpdate } from '../../../store/slices/tenantSlices/configurationSlice';

const AddEditSmtpModal = ({ isOpen, onCloseClick, isEdit = false, editRecord = null }) => {
  const dispatch = useDispatch();

  const initialValues = {
    smtp_host: '',
    smtp_port: '',
    smtp_user: '',
    smtp_password: '',
    from_email: '',
    from_name: '',
    is_active: 'true',
    secure: 'false'
  };

  const validationSchema = Yup.object({
    smtp_host: Yup.string().required('smtp host is required'),
    smtp_port: Yup.string().required('smtp port is required'),
    smtp_user: Yup.string().required('smtp user is required'),
    smtp_password: Yup.string().required('smtp password is required'),
    from_email: Yup.string().required('from email is required'),
    from_name: Yup.string().required('from name is required')
  });

  const onSubmit = async () => {
    if (isEdit) {
      try {
        const payload = { ...values, id: editRecord.id };
        const response = await dispatch(smtpUpdate(payload)).unwrap();
        if (response && response?.message) {
          toast.success('Record Updated Successfully');
          onCloseClick(true);
          resetForm();
        } else {
          toast.error(response.error);
        }
      } catch (error) {
        console.log('error', error);
      }
    } else {
      try {
        const payload = { ...values };
        const response = await dispatch(smtpAdd(payload)).unwrap();
        if (response && response?.message) {
          toast.success('Record Added Successfully');
          onCloseClick(true);
          resetForm();
        } else {
          toast.error(response.error);
        }
      } catch (error) {
        console.log('error', error);
      }
    }
  };

  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    errors,
    resetForm,
    setValues,
    setFieldValue
  } = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  });

  useEffect(() => {
    if (isEdit) {
      setValues({
        ...values,
        smtp_host: editRecord?.smtp_host || '',
        smtp_port: editRecord?.smtp_port || '',
        smtp_user: editRecord?.smtp_user || '',
        smtp_password: editRecord?.smtp_password || '',
        from_email: editRecord?.from_email || '',
        from_name: editRecord?.from_name || '',
        is_active: String(editRecord?.is_active) || 'true',
        secure: String(editRecord?.secure) || 'false'
      });
    }
  }, [editRecord]);

  return (
    <Modal isOpen={isOpen} size="xl" centered>
      <ModalHeader className="justify-content-center py-2">
        <div className="fs-5">{isEdit ? 'Edit SMTP' : 'Add SMTP'}</div>
      </ModalHeader>
      <ModalBody className="px-4">
        <form id="crms" onSubmit={handleSubmit}>
          <Row>
            <Col lg="3">
              <FormInput
                name="smtp_host"
                label="SMTP Host"
                placeholder="Enter SMTP Host"
                value={values.smtp_host}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
              />
            </Col>
            <Col lg="3">
              <FormInput
                name="smtp_port"
                label="SMTP Port"
                placeholder="Enter SMTP Port"
                value={values.smtp_port}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
              />
            </Col>
            <Col lg="3">
              <FormInput
                name="smtp_user"
                label="SMTP User"
                placeholder="Enter SMTP User"
                value={values.smtp_user}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
              />
            </Col>
            <Col lg="3">
              <FormInput
                name="smtp_password"
                label="SMTP Password"
                placeholder="Enter SMTP Password"
                value={values.smtp_password}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
              />
            </Col>
            <Col lg="3">
              <FormInput
                name="from_email"
                label="From Email"
                placeholder="Enter From Email"
                value={values.from_email}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
              />
            </Col>
            <Col lg="3">
              <FormInput
                name="from_name"
                label="From Name"
                placeholder="Enter From Name"
                value={values.from_name}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
              />
            </Col>
            <Col lg="3">
              <FormToggle
                name="is_active"
                label="Active"
                value={values.is_active}
                onChange={(e) => setFieldValue('is_active', e)}
              />
            </Col>
            <Col lg="3">
              <FormToggle
                name="secure"
                label="Secure"
                value={values.secure}
                onChange={(e) => setFieldValue('secure', e)}
              />
            </Col>
          </Row>
        </form>
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            onCloseClick();
            resetForm();
          }}
          className="px-5 bg-transparent text-primary">
          Cancel
        </Button>
        <Button form="crms" type="submit" className="px-5 bg-primary border-primary">
          {isEdit ? 'Update' : 'Save'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

AddEditSmtpModal.propTypes = {
  isOpen: PropTypes.bool,
  isEdit: PropTypes.bool,
  onCloseClick: PropTypes.func,
  editRecord: PropTypes.any
};

export default AddEditSmtpModal;
